import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en';
import daTranslation from './locales/da';

// Initialize i18next
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation
            },
            da: {
                translation: daTranslation
            }
        },
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            // React already safes from xss
            escapeValue: false
        }
    });

// Trigger a brief global CSS animation when language changes
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    i18n.on('languageChanged', () => {
        const root = document.documentElement;
        // Add a transient class to drive CSS animations
        root.classList.add('lang-changing');
        window.setTimeout(() => {
            root.classList.remove('lang-changing');
        }, 380);
    });
}

export default i18n; 